module.exports = __webpack_public_path__ + "img/dashboard.dadd9488.svg";